<template>
  <el-dialog
    title="图片预览"
    :visible="visible"
    :append-to-body="true"
    width="70%"
    @close="closeHandler"
  >
    <el-row class="my-row" v-show="imgUrl">
      <el-button type="primary" icon="el-icon-refresh-right" circle @click="rotate(1)"></el-button>
      <el-button type="primary" icon="el-icon-refresh-left" circle @click="rotate(0)"></el-button>
    </el-row>
    <img
      :src="imgUrl"
      alt
      id="myImage"
      class="myImage"
    />
  </el-dialog>
</template>

<script>
  export default {
    name: "rotatableImg",
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      imgUrl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        index: 0
      }
    },
    methods: {
      closeHandler() {
        this.$emit('close');
      },
      rotate(flag) {
        // flag 1:顺时针旋转；0：逆时针旋转
        flag ? this.index = this.index+1 : this.index = this.index-1;
        let image = document.getElementById("myImage"); // 获取要操作的图片元素
        let transformStyle = "rotate(" + (90 * this.index) + "deg)";
        image.style.transform = transformStyle;
      }
    }
  }
</script>

<style scoped>
  .my-row {
    text-align: center;
    top: 45px;
    position: relative;
    z-index: 9;
  }

  .myImage {
    max-width: 100%;
    max-height: 100%;
    display: inline-block;
    margin: -35px auto 0 auto;
  }
</style>
